import { render } from "./ProdutoPrecos.vue?vue&type=template&id=1715262e&scoped=true&ts=true"
import script from "./ProdutoPrecos.vue?vue&type=script&lang=ts"
export * from "./ProdutoPrecos.vue?vue&type=script&lang=ts"

import "./ProdutoPrecos.vue?vue&type=style&index=0&id=1715262e&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1715262e"]])

export default __exports__